import React from 'react';
import styled from 'styled-components';
import LazyImage from '../lazy-image';
import { getFluidGatsbyImage } from '../../utils/gatsby-storyblok-image-fixed';
import RichtextParser from '../../utils/richtext-parser';

const ContentCarouselSliderItemContainer = styled.div`
  transform: translate3d(0, 0, 0);
  flex: 0 0 clamp(606px, 70%, 906px);
  min-width: 0;
  margin-left: 40px;
  padding: 72px;
  background: #1d1d1d;

  border-radius: var(--Radius-Radius-3, 16px);
  display: flex;
  align-items: center;
  @media (max-width: 1100px) {
    padding: 48px;
  }

  @media (max-width: 976px) {
    flex-direction: column;
    padding: 0px;
    gap: 32px;
    margin-left: 20px;
  }
  @media (max-width: 768px) {
    flex: 0 0 80vw;
    margin-left: 16px;
  }
`;

const ContentCarouselSliderItemImage = styled.div`
  height: 200px;
  width: 200px;
  aspect-ratio: 1/1;
  background: rgba(255, 255, 255, 0.05);
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: var(--Radius-Radius-3, 16px);
  @media (max-width: 976px) {
    aspect-ratio: 16/9;
    width: 100%;
    height: auto;
  }
`;

const ContentCarouselSliderItemContent = styled.div`
  margin-left: 56px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  @media (max-width: 976px) {
    margin-left: 0;
    justify-content: flex-start;
    padding: 24px;
    padding-top: 0;
    padding-bottom: 24px;
  }
`;

const ContentCarouselSliderItemTitle = styled.h3`
  color: #fff;
  font-size: 27px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  letter-spacing: 0px;
  padding-bottom: 24px;
  text-wrap: pretty;
`;

const ContentCarouselSliderItemBody = styled.div`
  color: #c4c4c4;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0px;
  text-wrap: pretty;
`;

export default function ContentCarouselSliderItem({
  asset,
  title,
  bodyContent
}: {
  asset: any;
  title: string;
  bodyContent: any;
}) {
  return (
    <ContentCarouselSliderItemContainer className="embla__slide">
      <ContentCarouselSliderItemImage>
        <LazyImage
          fluid={getFluidGatsbyImage(asset)}
          width="100%"
          height="100%"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </ContentCarouselSliderItemImage>
      <ContentCarouselSliderItemContent>
        <ContentCarouselSliderItemTitle>{title}</ContentCarouselSliderItemTitle>
        <ContentCarouselSliderItemBody
          dangerouslySetInnerHTML={{ __html: RichtextParser(bodyContent) }}
        />
      </ContentCarouselSliderItemContent>
    </ContentCarouselSliderItemContainer>
  );
}
